import { cn } from "kz-ui-sdk";
import { ReactNode, useCallback } from "react";
import reactHotToast, { Toast } from "react-hot-toast";
import { MdCancel, MdNotifications } from "react-icons/md";

interface ActionToastProps {
  t: Toast;
  baseMessage: string;
  reasonLabel?: string;
  reasonValue?: string;
  actionButtonText: string;
  onActionClick: () => void;
  icon?: ReactNode;
}

export default function ActionToast({
  t,
  baseMessage,
  reasonLabel,
  reasonValue,
  actionButtonText,
  onActionClick,
  icon,
}: ActionToastProps) {
  const handleActionClick = useCallback(() => {
    reactHotToast.dismiss(t.id);
    onActionClick();
  }, [onActionClick, t.id]);

  const handleCloseClick = useCallback(() => {
    reactHotToast.dismiss(t.id);
  }, [t.id]);

  const fullMessage = reasonValue && reasonLabel ? `${baseMessage} ${reasonLabel}: ${reasonValue}` : baseMessage;

  return (
    <div className={cn("-ms-[2px] flex min-w-[244px] items-start gap-3")}>
      <div className="flex-shrink-0">{icon || <MdNotifications className="h-5 w-5 text-warning-base" />}</div>
      <div className="flex min-w-0 flex-1 flex-col gap-2">
        <div className="text-xs text-content-base">{baseMessage}</div>
        {reasonValue && reasonLabel && (
          <div className="text-xs text-content-base">
            {reasonLabel}: {reasonValue}
          </div>
        )}
        <button
          onClick={handleActionClick}
          className="mb-2 w-fit text-xs font-bold text-content-soft underline transition-colors hover:text-accentBrand-400"
          aria-label={`${actionButtonText} - ${fullMessage}`}
          data-element-id="button-action-toast"
        >
          {actionButtonText}
        </button>
      </div>
      <button
        onClick={handleCloseClick}
        className="translate-start-1/3 absolute end-0 top-0 -translate-y-1/3 text-accentBrand-300 transition-colors hover:text-accentBrand-400"
        aria-label={`Close toast: ${fullMessage}`}
        data-element-id="button-action-toast-close"
      >
        <MdCancel className="h-5 w-5 text-accentBrand-300" />
      </button>
    </div>
  );
}
